export const PERMISSION_STATE_FEATURE_KEY = 'permissionState';

export interface ModulePermission {
    accessKey: string;
    permissions: string[];
}

export interface PermissionState {
    pagePermissions: ModulePermission[];
    error?: any;
}
